import { useBgFormContext } from "@app/guranteeFormWrapper";
import { GUARANTEE_OPTIONS_AGENT } from "@app/guranteeFormWrapper/constants";
import { useStyles } from "@app/guranteeFormWrapper/styles";
import { FormSelect } from "@farzoom/common-ui-components";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { useFormContext } from "react-hook-form";

export const GuaranteeType = () => {
  const classes = useStyles();
  const { control, setValue } = useFormContext<BgFormInput>();
  const { formDisabled, prefix, canEditPurchase } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.guarantee` : "guarantee") as "guarantee";

  return (
    <FormSelect
      name={`${currentPrefix}.type`}
      className={classes.input}
      label="Вид банковской гарантии"
      setValue={setValue}
      control={control}
      defaultValue={null}
      options={GUARANTEE_OPTIONS_AGENT}
      disabled={formDisabled || !canEditPurchase}
      required
    />
  );
};
